import React from "react";
import { menuItems } from "../../../landing/data";
import SiteLogo from "../../SiteLogo";

export default function Footer() {
  return (
    <footer className="pt-10 bg-white border-t border-blue-sass/10 px-5 lg:px-0">
      <div className="flex flex-wrap justify-between gap-12 mx-auto mb-20 theme-container">
        <div className="w-fit max-w-[300px]">
          <SiteLogo />
          <a href="#home">
            <div className="home-two-btn-bg py-3.5 group bg-blue-sass border-blue-sass w-fit before:bg-white after:bg-white mt-10">
              <span className="relative z-10 text-base font-semibold text-white transition-all duration-300 group-hover:text-blue-sass font-inter">
                Start Free 30-days Trial
              </span>
              <svg
                className="relative z-10"
                width="7"
                height="12"
                viewBox="0 0 7 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  className="transition-all duration-300 group-hover:stroke-blue-sass"
                  d="M1.10254 10.5L4.89543 6.70711C5.22877 6.37377 5.39543 6.20711 5.39543 6C5.39543 5.79289 5.22877 5.62623 4.89543 5.29289L1.10254 1.5"
                  stroke="white"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </a>
        </div>
        <div className="w-fit max-w-[300px]">
          <div className="flex flex-col items-center">
            <div>
              <h1 className="font-semibold text-18 text-main-black">MENUS</h1>
              <ul className="mt-3.5">
                {menuItems.map((item, index) => (
                  <li key={index}>
                    <a href={item.link}>
                      <div className="relative flex items-center gap-2 pr-5 overflow-hidden font-medium transition-all duration-300 group text-paragraph hover:text-blue-sass hover:underline">
                        <svg
                          className="absolute transition-all duration-300 -left-2 group-hover:left-0"
                          width="6"
                          height="12"
                          viewBox="0 0 6 12"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M1 1L5 6L1 11"
                            stroke="currentColor"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                        <span className="transition-all duration-300 group-hover:translate-x-4">
                          {item.label}
                        </span>
                      </div>
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        <div className="w-fit max-w-[300px]">
          <div className="max-w-[223px]">
            <h1 className="font-semibold text-18 text-main-black">
              Office Address
            </h1>
            <div className="flex gap-2 items-center relative group font-medium text-paragraph mt-3.5">
              <span className="transition-all duration-300">
                KN 115 Street - Maison Tresor, 2nd Floor
              </span>
            </div>
            <h1 className="mt-6 font-semibold text-18 text-main-black">
              Contact
            </h1>
            <div className="flex gap-2 items-center relative group font-medium text-paragraph mt-3.5">
              <span className="transition-all duration-300">
                info@maneraconnect.com <br />
                +250 788 619 790
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="w-full h-[80px] md:h-[65px] py-10 md:py-0 my-20 md:my-0 bg-white border-t border-blue-sass/10">
        <div className="h-full mx-auto border-t theme-container border-white/10">
          <div className="flex flex-wrap items-center justify-between w-full h-full">
            <span className="text-paragraph">
              <span>{new Date()?.getFullYear()} © All rights reserved by</span>
              <a
                href="https://maneraconnect.com"
                target="__blank"
                className="text-blue-sass ml-1 font-bold"
              >
                MANERA CONNECT
              </a>
            </span>
            <div className="relative flex justify-center w-full sm:w-fit">
              <a
                href="#home"
                aria-label="go top"
                className="w-[45px] h-[45px] rounded-full border-[3px] border-white bg-blue-sass flex justify-center items-center absolute -top-[125px] sm:-top-[55px]"
              >
                <span>
                  <svg
                    width="55"
                    height="55"
                    viewBox="0 0 55 55"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="27.5" cy="27.5" r="27.5" fill="#2563EB" />
                    <path
                      d="M22 25.3333L27.3333 20M27.3333 20L32.6667 25.3333M27.3333 20V36"
                      stroke="white"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
              </a>
            </div>
            <ul className="flex items-center space-x-3 max-w-80 md:space-x-6">
              <li className="font-medium hover:text-main-black hover:underline common-transition text-paragraph">
                <a href="/">Privacy Policy</a>
              </li>
              <li className="font-medium text-paragraph">|</li>
              <li className="font-medium hover:text-main-black hover:underline common-transition text-paragraph">
                <a href="/">Terms & Conditions</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
}
